<template>
  <div class="card fuel-funds__card h-mobile-no-border-radius">
    <div class="card-header">
      <h1 class="fuel-funds__card-title">Transactions</h1>
    </div>
    <div class="card-body">
      <table class="maincol__table">
        <tr class="table__row table__row--head table__row--head--transactions">
          <td class="table__cell table__cell--description">Description</td>
          <td class="table__cell table__cell--date">Date</td>
          <td class="table__cell table__cell--amount">Amount</td>
          <td class="table__cell table__cell--action"></td>
        </tr>

        <FuelFundsTransaction v-for="(transaction, index) in transactions" :key="index" :transaction="transaction"></FuelFundsTransaction>

      </table>
    </div>
    <div class="card-footer">
      <div class="fuel-funds__card-total">
        <span class="fuel-funds__card-total--transactions">Total =</span> <span class="fuel-funds__total--amount">${{ transactionsTotal }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FuelFundsTransaction from './FuelFundsTransaction.vue';

  export default {
    name: 'FuelFundsTransactions',
    components: {
      FuelFundsTransaction,
    },
    computed: {
      ...mapGetters('fuelFunds', ['transactions', 'transactionsTotal']),
    },
  };
</script>
